module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-41.100249aa.png";